// Copyright (c) 2017 Deere & Company

import ReportHeader from './report-header';
import {connect} from 'react-redux';
import {sharedActionCreators} from '../../action-creators';

const getStateToBindToContainerProps = state => ({
    ...state.reportVariant,
    hiddenColumns: state.reportVariant.selectedLayout ?
        state.reportVariant.selectedLayout.columnState.filter(column => column.hide) :
        [],
    isSapUp: state.app.sapStatus.isSapUp
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    ...ownProps
});

export default connect(getStateToBindToContainerProps, sharedActionCreators, mapBoundActionCreatorsToActionsProp)(ReportHeader);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-header/index.js